<template>
	<div v-if="mounted" class="application-page skills">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="skills"/>
				</b-col>
				<b-col md="9">
					<div class="sticky-title" v-sticky>
						<h1>Meine Skills</h1>
					</div>
					<JonInfo class="mb-5">
						<template #message>
							Durch die vollständige Eingabe aller deiner Kompetenzen kannst du deine Chancen erhöhen!
						</template>
					</JonInfo>
					<div :class="['main-content', 'profile-view', {'loading-blockade': reloading}]">
						<div class="tag-sections">
							<section>
								<Title
									title="Softwarekompetenzen"
									parent
									:editable="false"
									:completion-type="getSectionsCompletionType([
										sections.skillsSoftwareMain,
										sections.skillsSoftwareSpecial
									])"
								/>
								<div class="sub-sections">
									<div v-if="isSectionEligible(sections.skillsSoftwareMain)" class="sub-section">
										<Title
											title="Bürosoftware"
											:completion-type="getSectionCompletionType(sections.skillsSoftwareMain)"
											@edit="$refs.skillsSoftwareMain.openFan()"
										/>
										<CharacteristicEdit
											v-model="skillsSoftwareMain"
											ref="skillsSoftwareMain"
											title="Software"
											:characteristic-items="meta.skillSoftwareMain"
											:characteristic-type="meta.skillSoftwareMainType"
											:nothing-allowed="{
												onlyOverall: true,
												overall: {
													text: 'Ich habe noch keine Erfahrung mit Bürosoftware',
													inFan: true
												}
											}"
											:selected-items-config="{
												styling: selectedItemsStylingList
											}"
											with-self-assessment
											:with-edit-button="false"
											:class="{'inline': hasNoSkillsSoftwareMain}"
											:header-info="headerInfoApplicationNoExperience"
											:completion-check-config="{
												enabled: true,
												label: 'Bürosoftware',
												okButtonText: 'Keine weitere Erfahrung mit Bürosoftware',
												popUpInfo: completionCheckInfos.softwareMain
											}"
											@finish="saveSkillsSoftwareMain"
										/>
									</div>
									<SkillsSoftwareSpecial
										v-if="isSectionEligible(sections.skillsSoftwareSpecial)"
										v-model="skillsSoftwareSpecial"
										:meta="meta"
										:completion-type="getSectionCompletionType(sections.skillsSoftwareSpecial)"
										@change="saveSkillsSoftwareSpecial"
									/>
								</div>
							</section>
							<!--<section v-if="isSectionEligible(sections.skills)">
								<Title
									title="Persönlichkeitseigenschaften / Soziale Kompetenzen"
									:completion-type="getSectionCompletionType(sections.skills)"
									parent
									@edit="$refs.skills.edit()"
								/>
								<Skills
									v-model="skills"
									ref="skills"
									:with-edit-button="false"
									@finish="saveSkills"
								/>
							</section>-->
							<Languages
								v-if="isSectionEligible(sections.languages)"
								v-model="languages"
								:meta="meta"
								:completion-type="getSectionCompletionType(sections.languages)"
								@change="saveLanguages"
							/>
							<section v-if="isSectionEligible(sections.experienceFunction)">
								<Title
									title="Tätigkeitserfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunction)"
									@edit="$refs.experienceFunctions.edit()"
								/>
								<Experience
									v-model="experienceFunctions"
									ref="experienceFunctions"
									:initial-data="experienceFunctions"
									:meta="meta"
									:characteristic-items="meta.function"
									:characteristic-type="meta.functionType"
									title="Welche Tätigkeitserfahrungen hast du?"
									nothing-overall-text="Ich habe noch keine Tätigkeitserfahrungen"
									experience-none-allowed
									with-keyword
									:with-edit-button="false"
									:supplements-config="{
										nothingAllowed: false,
										types: functionSupplementTypes
									}"
									:completion-check-config="{
										label: 'Tätigkeitserfahrung',
										infoLabel: 'Tätigkeitserfahrungen',
										okButtonText: 'Keine weitere Tätigkeitserfahrung'
									}"
									:search-config="{ catalog: meta.searchCatalogFunction }"
									@finish="saveExperience($event, true, 'experienceFunction', sections.experienceFunction)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceCareerLevel)">
								<Title
									title="Berufsebenen-Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceCareerLevel)"
									@edit="$refs.experienceCareerLevels.edit()"
								/>
								<Experience
									v-model="experienceCareerLevels"
									ref="experienceCareerLevels"
									:initial-data="experienceCareerLevels"
									:meta="meta"
									:characteristic-items="meta.careerLevel"
									:characteristic-type="meta.careerLevelType"
									title="Welche Berufsebenen-Erfahrung hast du?"
									nothing-overall-text="Ich habe noch keine Erfahrung"
									experience-none-allowed
									:with-keyword="false"
									:with-edit-button="false"
									:group-by-letter="{
										enabled: false
									}"
									:completion-check-config="{
										label: 'Berufsebenen-Erfahrung',
										infoLabel: 'Berufsebenen-Erfahrungen',
										okButtonText: 'Keine weitere Berufsebenen-Erfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceCareerLevel', sections.experienceCareerLevel)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceIndustrialSector)">
								<Title
									title="Branchenerfahrung (Branchen, Leistungen, Produkte)"
									parent
									:completion-type="getSectionCompletionType(sections.experienceIndustrialSector)"
									@edit="$refs.experienceIndustrialSectors.edit()"
								/>
								<Experience
									v-model="experienceIndustrialSectors"
									ref="experienceIndustrialSectors"
									:initial-data="experienceIndustrialSectors"
									:meta="meta"
									:characteristic-items="meta.industrialSector"
									:characteristic-type="meta.industrialSectorType"
									title="In welchen Branchen oder mit welchen Leistungen und Produkten hast du Erfahrung?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung in bestimmten Branchen"
									experience-none-allowed
									with-keyword
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Branchenerfahrung',
										infoLabel: 'Branchenerfahrungen',
										okButtonText: 'Keine weitere Branchenerfahrung'
									}"
									:search-config="{ catalog: meta.searchCatalogIndustrialSector }"
									@finish="saveExperience($event, true, 'experienceIndustrialSector', sections.experienceIndustrialSector)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceOrganisationalArea)">
								<Title
									title="Organisationsbereich-Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceOrganisationalArea)"
									@edit="$refs.experienceOrganisationalArea.edit()"
								/>
								<Experience
									v-model="experienceOrganisationalArea"
									ref="experienceOrganisationalArea"
									:initial-data="experienceOrganisationalArea"
									:meta="meta"
									:characteristic-items="meta.organisationalArea"
									:characteristic-type="meta.organisationalAreaType"
									title="In welchen Organisationsbereichen hast du Erfahrung?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung in bestimmten Organisationsbereichen"
									experience-none-allowed
									with-keyword
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Organisationsbereich-Erfahrung',
										infoLabel: 'Organisationsbereich-Erfahrungen',
										okButtonText: 'Keine weitere Organisationsbereich-Erfahrungen'
									}"
									@finish="saveExperience($event, true, 'experienceOrganisationalArea', sections.experienceOrganisationalArea)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceManagement)">
								<Title
									title="Führungsverantwortung - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceManagement)"
									@edit="$refs.experienceManagement.edit()"
								/>
								<Experience
									v-model="experienceManagement"
									ref="experienceManagement"
									:initial-data="experienceManagement"
									:meta="meta"
									:characteristic-items="meta.managementKind"
									:characteristic-type="meta.managementKindType"
									title="Erfahrung mit Führungsverantwortung"
									nothing-overall-text="Ich habe noch keine Vorerfahrung mit Führungsverantwortung"
									experience-none-allowed
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Erfahrung mit Führungsverantwortung',
										infoLabel: 'Führungserfahrungen',
										okButtonText: 'Keine weitere Führungserfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceManagement', sections.experienceManagement)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceCustomerContact)">
								<Title
									title="Erfahrung im Kontakt mit externen Personen / Kunden"
									tooltip="Externe Personen sind zB Klienten, Kunden, Patienten, Interessenten, Bürger und andere"
									parent
									:completion-type="getSectionCompletionType(sections.experienceCustomerContact)"
									@edit="$refs.experienceCustomerContact.edit()"
								/>
								<Experience
									v-model="experienceCustomerContact"
									ref="experienceCustomerContact"
									:initial-data="experienceCustomerContact"
									:meta="meta"
									:characteristic-items="meta.businessModel"
									:characteristic-type="meta.businessModelType"
									experience-none-allowed
									title="Erfahrung im Kontakt mit externen Personen, wie Kunden, Klienten, Patienten, Interessenten, Bürger und andere"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Erfahrung im Kontakt mit externen Personen',
										infoLabel: 'Erfahrungen',
										okButtonText: 'Keine weitere Erfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceCustomerContact', sections.experienceCustomerContact)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceFunctionMarketingRole)">
								<Title
									title="Marketingtätigkeiten - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunctionMarketingRole)"
									@edit="$refs.experienceFunctionMarketingRole.edit()"
								/>
								<Experience
									v-model="experienceFunctionMarketingRole"
									ref="experienceFunctionMarketingRole"
									:initial-data="experienceFunctionMarketingRole"
									:meta="meta"
									:characteristic-items="meta.functionMarketingRole"
									:characteristic-type="meta.functionMarketingRoleType"
									title="Hast du mit bestimmten Marketingtätigkeiten Erfahrung gesammelt?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									:with-keyword="false"
									:with-experience="true"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Marketingtätigkeiten - Erfahrung',
										infoLabel: 'Marketingtätigkeits-Erfahrungen',
										okButtonText: 'Keine weitere Marketingerfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceFunctionMarketingRole', sections.experienceFunctionMarketingRole)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceFunctionLegalField)">
								<Title
									title="Rechtsgebiete - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunctionLegalField)"
									@edit="$refs.experienceFunctionLegalField.edit()"
								/>
								<Experience
									v-model="experienceFunctionLegalField"
									ref="experienceFunctionLegalField"
									:initial-data="experienceFunctionLegalField"
									:meta="meta"
									:characteristic-items="meta.functionLegalField"
									:characteristic-type="meta.functionLegalFieldType"
									title="Hast du mit bestimmten Rechtsgebieten Erfahrung gesammelt?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									experience-none-allowed
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Rechtsgebiete - Erfahrung',
										infoLabel: 'Rechtsgebiets-Erfahrungen',
										okButtonText: 'Keine weitere Rechtsgebiete-Erfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceFunctionLegalField', sections.experienceFunctionLegalField)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceFunctionLegalRole)">
								<Title
									title="Rechtstätigkeiten - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunctionLegalRole)"
									@edit="$refs.experienceFunctionLegalRole.edit()"
								/>
								<Experience
									v-model="experienceFunctionLegalRole"
									ref="experienceFunctionLegalRole"
									:initial-data="experienceFunctionLegalRole"
									:meta="meta"
									:characteristic-items="meta.functionLegalRole"
									:characteristic-type="meta.functionLegalRoleType"
									title="Hast du mit bestimmten Rechtstätigkeiten Erfahrung gesammelt?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									:with-experience="true"
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Rechtstätigkeiten - Erfahrung',
										infoLabel: 'Rechtstätigkeits-Erfahrungen',
										okButtonText: 'Keine weitere Rechtstätigkeits-Erfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceFunctionLegalRole', sections.experienceFunctionLegalRole)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceFunctionTaxField)">
								<Title
									title="Steuergebiete - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunctionTaxField)"
									@edit="$refs.experienceFunctionTaxField.edit()"
								/>
								<Experience
									v-model="experienceFunctionTaxField"
									ref="experienceFunctionTaxField"
									:initial-data="experienceFunctionTaxField"
									:meta="meta"
									:characteristic-items="meta.functionTaxField"
									:characteristic-type="meta.functionTaxFieldType"
									title="Hast du mit bestimmten Steuergebieten Erfahrung gesammelt?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									experience-none-allowed
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Steuergebiete - Erfahrung',
										infoLabel: 'Steuergebiets-Erfahrungen',
										okButtonText: 'Keine weitere Steuergebietserfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceFunctionTaxField', sections.experienceFunctionTaxField)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.experienceFunctionTaxRole)">
								<Title
									title="Steuertätigkeiten - Erfahrung"
									parent
									:completion-type="getSectionCompletionType(sections.experienceFunctionTaxRole)"
									@edit="$refs.experienceFunctionTaxRole.edit()"
								/>
								<Experience
									v-model="experienceFunctionTaxRole"
									ref="experienceFunctionTaxRole"
									:initial-data="experienceFunctionTaxRole"
									:meta="meta"
									:characteristic-items="meta.functionTaxRole"
									:characteristic-type="meta.functionTaxRoleType"
									title="Hast du mit bestimmten Steuertätigkeiten Erfahrung gesammelt?"
									nothing-overall-text="Ich habe noch keine Vorerfahrung"
									:with-experience="true"
									:with-keyword="false"
									:with-edit-button="false"
									:completion-check-config="{
										label: 'Steuertätigkeiten - Erfahrung',
										infoLabel: 'Steuertätigkeits-Erfahrungen',
										okButtonText: 'Keine weitere Steuertätigkeitserfahrung'
									}"
									@finish="saveExperience($event, false, 'experienceFunctionTaxRole', sections.experienceFunctionTaxRole)"
								/>
							</section>
							<section v-if="isSectionEligible(sections.drivingLicense)">
								<Title
									title="Führerscheine"
									:completion-type="getSectionCompletionType(sections.drivingLicense)"
									parent
									@edit="$refs.drivingLicense.openFan()"
								/>
								<CharacteristicEdit
									v-model="drivingLicense"
									ref="drivingLicense"
									title="Führerscheine"
									:characteristic-items="meta.drivingLicenseClass"
									:characteristic-type="meta.drivingLicenseClassType"
									:nothing-allowed="{
										onlyOverall: true,
										overall: {
											text: 'Ich habe keinen Führerschein',
											inFan: true
										}
									}"
									icon-path="/img/characteristic/driving-license"
									:description-config="{
										inline: true
									}"
									:with-edit-button="false"
									:class="{'inline': hasNoDrivingLicenses}"
									:completion-check-config="{
										enabled: true,
										label: 'Führerscheine',
										okButtonText: 'Keine weiteren Führerscheine',
										popUpInfo: completionCheckInfos.drivingLicense
									}"
									@finish="saveDrivingLicenses"
								/>
							</section>
							<section v-if="isSectionEligible(sections.pilotLicense)">
								<Title
									title="Flugscheine"
									:completion-type="getSectionCompletionType(sections.pilotLicense)"
									parent
									@edit="$refs.pilotLicense.openFan()"
								/>
								<CharacteristicEdit
									v-model="pilotLicense"
									ref="pilotLicense"
									title="Flugscheine"
									:characteristic-items="meta.pilotLicense"
									:characteristic-type="meta.pilotLicenseType"
									:nothing-allowed="{
										onlyOverall: true,
										overall: {
											text: 'Ich habe keinen Flugschein',
											inFan: true
										}
									}"
									:with-edit-button="false"
									:class="{'inline': hasNoPilotLicenses}"
									:completion-check-config="{
										enabled: true,
										label: 'Flugscheine',
										okButtonText: 'Keine weiteren Flugscheine',
										popUpInfo: completionCheckInfos.pilotLicense
									}"
									@finish="savePilotLicenses"
								/>
							</section>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";
import Navigation from "@/vue/application/profile/Navigation";
import Experience from "@/vue/application/Experience";
import Skills from "@/vue/application/Skills";
import SkillsSoftwareSpecial from "@/vue/application/profile/skills/SkillsSoftwareSpecial";
import Languages from "@/vue/application/profile/skills/Languages";
import DrivingLicense from "@/vue/application/DrivingLicense";
import Button from "@/vue/common/Button";
import {prepareCharacteristicSkippable, prepareExperienceSkippable} from "@/helper/application/Preparation";
import ApplicationSkillsSave from "@/api/application/skills/Save";
import Loading from "@/vue/common/Loading";
import {mapState} from "vuex";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {isDefined} from "@/helper/Value";
import SelectInline from "@/vue/characteristic/SelectInline";
import {characteristicMultiple} from "@/helper/application/Populate";
import Icon from "@/vue/icon/Icon";
import Title, {COMPLETION_TYPE__COMPLETED, COMPLETION_TYPE__INCOMPLETE} from "@/vue/common/profile-view/Title.vue";
import * as Section from "@/helper/application/Section";
import {isEmptyArray} from "@/helper/Array";
import {STYLING__LIST} from "@/vue/characteristic/SelectedItems"
import {HEADER_INFO__APPLICATION_NO_EXPERIENCE} from "@/vue/characteristic/Fan"
import {
	APPLICATION_DRIVING_LICENSE,
	APPLICATION_PILOT_LICENSE,
	APPLICATION_SOFTWARE_MAIN
} from "@/helper/characteristic/completion-check/Info";
import JonInfo from "@/vue/common/JonInfo";
import _ from "lodash";
import {reload} from "@/helper/Window";
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";

export default {

	components: {
		Title,
		SelectInline,
		Loading,
		CharacteristicEdit,
		Navigation,
		Experience,
		Skills,
		SkillsSoftwareSpecial,
		Languages,
		DrivingLicense,
		Button,
		Icon,
		JonInfo,
	},

	props: {
		applicationData64: {
			type: String,
			required: true,
		},
		eligibleSections64: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		if (
			!this.isSectionCompleted(this.sections.experienceFunction)
			&& isEmptyArray(this.experienceFunctions)
		)
		{
			this.experienceFunctions = undefined;
		}

		if (
			!this.isSectionCompleted(this.sections.experienceCareerLevel)
			&& isEmptyArray(this.experienceCareerLevels)
		)
		{
			this.experienceCareerLevels = undefined;
		}

		if (
			!this.isSectionCompleted(this.sections.experienceIndustrialSector)
			&& isEmptyArray(this.experienceIndustrialSectors)
		)
		{
			this.experienceIndustrialSectors = undefined;
		}

		if (
			!this.isSectionCompleted(this.sections.experienceOrganisationalArea)
			&& isEmptyArray(this.experienceOrganisationalArea)
		)
		{
			this.experienceOrganisationalArea = undefined;
		}

		if (isDefined(this.applicationData.languages))
		{
			this.languages = characteristicMultiple(
				this.applicationData.languages,
				this.meta,
				this.meta.language,
				this.meta.languageType,
				true
			);
		}

		if (isDefined(this.applicationData.skills))
		{
			this.skills = characteristicMultiple(
				this.applicationData.skills,
				this.meta,
				this.meta.skill,
				this.meta.skillType,
				true
			);
		}

		if (isDefined(this.applicationData.skillsSoftwareMain))
		{
			this.skillsSoftwareMain = characteristicMultiple(
				this.applicationData.skillsSoftwareMain,
				this.meta,
				this.meta.skillSoftwareMain,
				this.meta.skillSoftwareMainType,
				true
			);
		}

		if (isDefined(this.applicationData.skillsSoftwareSpecial))
		{
			this.skillsSoftwareSpecial = characteristicMultiple(
				this.applicationData.skillsSoftwareSpecial,
				this.meta,
				this.meta.skillSoftwareSpecial,
				this.meta.skillSoftwareSpecialType,
				false
			);
		}

		if (isDefined(this.applicationData.drivingLicense))
		{
			this.drivingLicense = characteristicMultiple(
				this.applicationData.drivingLicense.classes,
				this.meta,
				this.meta.drivingLicenseClass,
				this.meta.drivingLicenseClassType
			);
		}

		if (isDefined(this.applicationData.pilotLicense))
		{
			this.pilotLicense = characteristicMultiple(
				this.applicationData.pilotLicense,
				this.meta,
				this.meta.pilotLicense,
				this.meta.pilotLicenseType
			);
		}

		if (isDefined(this.applicationData.experienceFunctionLegalField))
		{
			this.experienceFunctionLegalField = characteristicMultiple(
				this.applicationData.experienceFunctionLegalField,
				this.meta,
				this.meta.functionLegalField,
				this.meta.functionLegalFieldType,
				true
			);
		}

		if (isDefined(this.applicationData.experienceFunctionLegalRole))
		{
			this.experienceFunctionLegalRole = characteristicMultiple(
				this.applicationData.experienceFunctionLegalRole,
				this.meta,
				this.meta.functionLegalRole,
				this.meta.functionLegalRoleType,
				true
			);
		}

		if (isDefined(this.applicationData.experienceFunctionTaxField))
		{
			this.experienceFunctionTaxField = characteristicMultiple(
				this.applicationData.experienceFunctionTaxField,
				this.meta,
				this.meta.functionTaxField,
				this.meta.functionTaxFieldType,
				true
			);
		}

		if (isDefined(this.applicationData.experienceFunctionTaxRole))
		{
			this.experienceFunctionTaxRole = characteristicMultiple(
				this.applicationData.experienceFunctionTaxRole,
				this.meta,
				this.meta.functionTaxRole,
				this.meta.functionTaxRoleType,
				true
			);
		}

		if (isDefined(this.applicationData.experienceFunctionMarketingRole))
		{
			this.experienceFunctionMarketingRole = characteristicMultiple(
				this.applicationData.experienceFunctionMarketingRole,
				this.meta,
				this.meta.functionMarketingRole,
				this.meta.functionMarketingRoleType,
				true
			);
		}

		this.mounted = true;
	},

	data ()
	{
		let applicationData = {};

		if (this.applicationData64)
		{
			applicationData = JSON.parse(
				window.atob(this.applicationData64)
			);
		}

		return {
			mounted: false,
			eligibleSections: JSON.parse(
				window.atob(this.eligibleSections64)
			),
			applicationData,
			experienceFunctions: applicationData.experienceFunctions,
			experienceCareerLevels: applicationData.experienceCareerLevels,
			experienceIndustrialSectors: applicationData.experienceIndustrialSectors,
			experienceOrganisationalArea: applicationData.experienceOrganisationalArea,
			experienceManagement: applicationData.experienceManagement,
			experienceCustomerContact: applicationData.experienceCustomerContact,
			experienceFunctionLegalField: applicationData.experienceFunctionLegalField,
			experienceFunctionLegalRole: applicationData.experienceFunctionLegalRole,
			experienceFunctionTaxField: applicationData.experienceFunctionTaxField,
			experienceFunctionTaxRole: applicationData.experienceFunctionTaxRole,
			experienceFunctionMarketingRole: applicationData.experienceFunctionMarketingRole,
			skills: undefined,
			skillsSoftwareMain: undefined,
			skillsSoftwareSpecial: undefined,
			languages: applicationData.languages,
			drivingLicense: undefined,
			pilotLicense: undefined,
			sectionCompletions: applicationData.sectionCompletions,
			reloading: false,
		};
	},

	computed: {
		...mapState('meta', [
			'meta'
		]),
		functionSupplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		},
		completionCheckInfos ()
		{
			return {
				softwareMain: APPLICATION_SOFTWARE_MAIN,
				drivingLicense: APPLICATION_DRIVING_LICENSE,
				pilotLicense: APPLICATION_PILOT_LICENSE,
			};
		},
		sections ()
		{
			return {
				skills: Section.SKILLS,
				skillsSoftwareMain: Section.SKILLS_SOFTWARE_MAIN,
				skillsSoftwareSpecial: Section.SKILLS_SOFTWARE_SPECIAL,
				languages: Section.LANGUAGES,
				experienceManagement: Section.EXPERIENCE_MANAGEMENT,
				experienceCustomerContact: Section.EXPERIENCE_CUSTOMER_CONTACT,
				experienceFunction: Section.EXPERIENCE_FUNCTION,
				experienceCareerLevel: Section.EXPERIENCE_CAREER_LEVEL,
				experienceIndustrialSector: Section.EXPERIENCE_INDUSTRIAL_SECTOR,
				experienceOrganisationalArea: Section.EXPERIENCE_ORGANISATIONAL_AREA,
				experienceFunctionLegalRole: Section.EXPERIENCE_FUNCTION_LEGAL_ROLE,
				experienceFunctionLegalField: Section.EXPERIENCE_FUNCTION_LEGAL_FIELD,
				experienceFunctionTaxRole: Section.EXPERIENCE_FUNCTION_TAX_ROLE,
				experienceFunctionTaxField: Section.EXPERIENCE_FUNCTION_TAX_FIELD,
				experienceFunctionMarketingRole: Section.EXPERIENCE_FUNCTION_MARKETING_ROLE,
				drivingLicense: Section.DRIVING_LICENSE,
				pilotLicense: Section.PILOT_LICENSE,
			};
		},
		hasNoSkillsSoftwareMain ()
		{
			return isEmptyArray(this.skillsSoftwareMain);
		},
		hasNoDrivingLicenses ()
		{
			return isEmptyArray(this.drivingLicense);
		},
		hasNoPilotLicenses ()
		{
			return isEmptyArray(this.pilotLicense);
		},
		selectedItemsStylingList ()
		{
			return STYLING__LIST;
		},
		headerInfoApplicationNoExperience ()
		{
			return HEADER_INFO__APPLICATION_NO_EXPERIENCE;
		},
	},

	methods: {
		isSectionCompleted (sectionId)
		{
			return isDefined(
				_.find(
					this.sectionCompletions,
					completion => completion.section === sectionId && !completion.skipped
				)
			);
		},
		isSectionEligible (sectionId)
		{
			return _.includes(this.eligibleSections, sectionId);
		},
		getSectionCompletionType (sectionId)
		{
			return this.isSectionCompleted(sectionId)
				? COMPLETION_TYPE__COMPLETED
				: COMPLETION_TYPE__INCOMPLETE;
		},
		getSectionsCompletionType (sectionIds)
		{
			let completions = 0;
			let incompletions = 0;

			sectionIds.forEach(sectionId =>
			{
				if (this.isSectionCompleted(sectionId))
				{
					completions++;
				}
				else
				{
					incompletions++;
				}
			});

			return incompletions === 0
				? COMPLETION_TYPE__COMPLETED
				: COMPLETION_TYPE__INCOMPLETE;
		},
		markSectionCompleted (sectionId)
		{
			if (this.isSectionCompleted(sectionId))
			{
				return;
			}

			this.sectionCompletions.push({
				section: sectionId,
				skipped: false,
			});
		},
		markSectionSkipped (sectionId, skipped)
		{
			if (skipped === undefined)
			{
				return;
			}

			if (!skipped)
			{
				this.markSectionCompleted(sectionId);
				return;
			}

			const sectionCompletions = _.filter(this.sectionCompletions, item => item.section !== sectionId);

			sectionCompletions.push({
				section: sectionId,
				skipped: true,
			});

			this.sectionCompletions = sectionCompletions;
		},
		async saveExperience (data, withSelfAssessment, property, sectionId)
		{
			const items = data.items;

			const itemsValid = {
				selected: items,
				withExperience: true,
				withSelfAssessment
			};

			if (items === undefined || !itemsValid)
			{
				return;
			}

			let skipped;

			if (items && items.length === 0)
			{
				skipped = false;
			}
			else
			{
				skipped = data.skipped ?? !this.isSectionCompleted(sectionId);
			}

			this.save({
				[property]: prepareExperienceSkippable(data, skipped)
			});

			this.markSectionSkipped(sectionId, skipped);
		},
		async saveSkillsSoftwareMain (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.SKILLS_SOFTWARE_MAIN);

			if (data.items && data.items.length === 0)
			{
				skipped = false;
			}

			this.save({
				skillsSoftwareMain: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.SKILLS_SOFTWARE_MAIN, skipped);
		},
		async saveSkills (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.SKILLS);

			if (data.items && data.items.length === 0)
			{
				skipped = false;
			}

			this.save({
				skills: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.SKILLS, skipped);
		},
		async saveSkillsSoftwareSpecial (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.SKILLS_SOFTWARE_SPECIAL);

			if (data.items && data.items.length === 0)
			{
				skipped = false;
			}

			this.save({
				skillsSoftwareSpecial: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.SKILLS_SOFTWARE_SPECIAL, skipped);
		},
		async saveLanguages (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.LANGUAGES);

			this.save({
				languages: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.LANGUAGES, skipped);
		},
		async saveDrivingLicenses (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.DRIVING_LICENSE);

			if (data.items && data.items.length === 0)
			{
				skipped = false;
			}

			this.save({
				drivingLicense: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.DRIVING_LICENSE, skipped);
		},
		async savePilotLicenses (data)
		{
			let skipped = data.skipped ?? !this.isSectionCompleted(Section.PILOT_LICENSE);

			if (data.items && data.items.length === 0)
			{
				skipped = false;
			}

			this.save({
				pilotLicense: prepareCharacteristicSkippable(data, skipped)
			});

			this.markSectionSkipped(Section.PILOT_LICENSE, skipped);
		},
		async save (data)
		{
			try
			{
				this.reloading = true;

				await new ApplicationSkillsSave()
					.setData(data)
					.call();

				reload();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}
		}
	}
}
</script>
